import React, { useEffect, useRef, useState } from 'react'
import { DownArrow } from 'shared-components/Components/CustomIcons/DownArrow/web'
import './styles.less'

type Props = {
  children: React.ReactNode
  label: string
  customWidth?: number
  positionRight?: boolean
  buttonRef?:React.MutableRefObject<any>
  customHeight?:number | string
}

const InputFilterBox = (props: Props) => {
  const boxRef = useRef(null)
  const [showOptions, setShowOptions] = useState<boolean>(false)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    const submitHandleClick = (event)=>{
      if(props.buttonRef && props.buttonRef.current.contains(event.target))setShowOptions(false)
      else return
    }
    //cuando aprete la tecla ESCAPE se ocultará el dropdown
    const handleKeyPress = (event) => {
      if (event.keyCode === 27) {
        setShowOptions(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('click', submitHandleClick);
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('click', submitHandleClick);
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <>
      <div className='inputFilterBox' ref={boxRef}>
        <div className={`inputFilterBox__label${showOptions ? ' inputActive' : ''}`} onClick={() => setShowOptions(!showOptions)}>
          <p>{props.label}</p>
          <DownArrow />
        </div>
        <div className={`inputFilterBox__content${showOptions ? ' showContentFilter' : ''}`} style={{ maxWidth: props.customWidth && props.customWidth,minHeight:props.customHeight?props.customHeight:'unset', minWidth: props.customWidth && props.customWidth, right: props.positionRight && 0, left: props.positionRight ? null : 0, transformOrigin: `top ${props.positionRight ? 'right' : 'left'}` }}>
          {props.children}
        </div>
      </div>
    </>
  )
}

export default InputFilterBox